export default __webpack_public_path__ + "static/media/GettyImages-1171155491-small.955b0de2.jpg";